// A nav item is active when the current route, or one of its parent routes,
// is the item's route or one of its activeRoutes (e.g. detail pages).
export function isNavItemActive(route, item) {
  const routeNames = [item.pathName, ...(item.activeRoutes || [])].filter(Boolean);

  return route.matched.some(record => routeNames.includes(record.name));
}
